@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.lpa

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.PlayArrow
import us.laantech.laanmanage.icons.Download
import us.laantech.laanmanage.icons.Pause
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.Slider
import androidx.compose.material3.SliderDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import io.github.kdroidfilter.composemediaplayer.VideoPlayerState
import io.github.kdroidfilter.composemediaplayer.VideoPlayerSurface
import io.github.kdroidfilter.composemediaplayer.rememberVideoPlayerState
import io.ktor.client.call.*
import io.ktor.client.request.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import us.laantech.common.dto.company.CompanyBranch
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.dto.PosTransactionDTO
import us.laantech.common.dto.company.ParentCompany
import us.laantech.common.ui.DataTableView
import us.laantech.common.ui.DateTimeEntryModal
import us.laantech.common.ui.DropdownMenu
import us.laantech.common.util.toBigDecimalDollarsFromCents
import us.laantech.common.util.tryFormatAsDateTime
import us.laantech.common.api.KtorClient
import us.laantech.laanmanage.feature.scope.ParentCompanyScope
import us.laantech.laanmanage.util.downloadFileFromUrl
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days

data class LossPreventionUiState(
    val transactions: List<PosTransactionDTO> = emptyList(),
    val selectedTransaction: PosTransactionDTO? = null,

    val videoUrl: String? = null,

    // Filters
    val fromMillis: Long = Clock.System.now().toEpochMilliseconds() - 7.days.inWholeMilliseconds,
    val toMillis: Long = Clock.System.now().toEpochMilliseconds(),

    val employees: List<EmployeeDTO> = emptyList(),
    val selectedEmployee: EmployeeDTO? = null,

    val branches: List<CompanyBranch> = emptyList(),
    val selectedBranch: CompanyBranch? = null,

    val playerState: VideoPlayerState? = null,

    val isLoadingVideo: Boolean = false,

    val showFromDatePicker: Boolean = false,
    val showToDatePicker: Boolean = false,

    ) {

}


@Composable
fun LossPreventionView(
    viewModel: LossPreventionViewModel = viewModel(
        factory = viewModelFactory {
            initializer { LossPreventionViewModel() }
        }
    )
) {

    val uiState by viewModel.uiState.collectAsState()
    LaunchedEffect(Unit) {
        viewModel.loadBranches()
        viewModel.loadTransactions()
    }

    val playerState = rememberVideoPlayerState()

    LaunchedEffect(uiState.videoUrl) {
        uiState.videoUrl?.let {
            playerState.openUri(it)
            playerState.play()
        }
    }

    ParentCompanyScope { parentCompany, companyBranch ->
        LaunchedEffect(parentCompany) {
            viewModel.loadEmployees(parentCompany)
        }
    }


    Column(modifier = Modifier.fillMaxSize()) {
//        VideoPlayerSurface(playerState, modifier = Modifier.weight(1f).fillMaxSize()) {
//            Text("Video")
//        }

        Row(modifier = Modifier.fillMaxHeight(0.5f)) {
            // Receipt

            Column(Modifier.fillMaxSize().weight(1f)) {
                Text("Receipt")
                uiState.selectedTransaction?.let {
                    Text(it.transactionId.toString())
                }
            }

            // Video Player
            Column(modifier = Modifier.fillMaxSize().weight(2f)) {
                Text("Video")
                var isHovered by remember { mutableStateOf(false) }
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxSize()
                        .pointerInput(Unit) {
                            awaitPointerEventScope {
                                while (true) {
                                    val event = awaitPointerEvent()
                                    when (event.type) {
                                        PointerEventType.Enter -> isHovered = true
                                        PointerEventType.Exit -> isHovered = false
                                    }
                                }
                            }
                        }
                ) {
                    VideoPlayerSurface(
                        playerState,
                        modifier = Modifier.fillMaxSize(),
                        overlay = {
                            Column(
                                Modifier.fillMaxSize(),
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.Bottom
                            ) {
                                // Loading overlay — shown on top of everything while buffering
                                if (playerState.isLoading) {
                                    Box(
                                        modifier = Modifier.fillMaxSize().background(Color.Black.copy(alpha = 0.5f)),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        CircularProgressIndicator(color = Color.White)
                                    }
                                }
                                if (isHovered) {
                                    VideoPlayerControls(playerState, viewModel)
                                }
                            }
                        })
                }
            }
        }

        // filters
        FilterRow(Modifier.fillMaxWidth().padding(4.dp), viewModel = viewModel)

        DataTableView(rows = uiState.transactions) {

            column("Store") {
                val branchName = uiState.branches.find { branch ->
                    branch.uuid == it.branchUuid
                }?.branchName ?: "Unknown"
                Text(branchName, modifier = Modifier.weight(1f))
            }

            column("Employee") {
                val employeeName = uiState.employees.find { employee ->
                    employee.uuid == it.employeeUUID
                }?.employeeName ?: "Unknown"
                Text(employeeName, modifier = Modifier.weight(1f))
            }

            column("POS") {
                Text(it.posDeviceId.toString(), modifier = Modifier.weight(1f))
            }
            column("Created") {
                Text(it.createdAt?.tryFormatAsDateTime() ?: "Invalid Date", modifier = Modifier.weight(1f))
            }

            column("Total", 0.5f) {
                val displayStr = it.totalCents?.toBigDecimalDollarsFromCents()?.toPlainString() ?: "N/A"
                Text(displayStr, modifier = Modifier.weight(0.5f))
            }

            column("Cash", 0.5f) {
                val displayStr = it.cashTenderedAmountCents?.toBigDecimalDollarsFromCents()?.toPlainString() ?: "N/A"
                Text(displayStr, modifier = Modifier.weight(0.5f))
            }
            column("Card", 0.5f) {
                val displayStr = it.cardTenderedAmountCents?.toBigDecimalDollarsFromCents()?.toPlainString() ?: "N/A"
                Text(displayStr, modifier = Modifier.weight(0.5f))
            }
            column("View") {
                Button(
                    onClick = { viewModel.selectTransaction(it) },
                    modifier = Modifier.weight(0.5f)
                ) {
                    Text("View")
                }
            }

        }

    }

    if (uiState.showFromDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.fromMillis,
            title = "Select Start Date",
            onDismiss = { viewModel.closeFromDatePicker() },
            onConfirm = { epochMillis ->
                viewModel.updateFromTime(epochMillis)
                viewModel.closeFromDatePicker()
            },
        )
    } else if (uiState.showToDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.toMillis,
            title = "Select End Date",
            onDismiss = { viewModel.closeToDatePicker() },
            onConfirm = { epochMillis ->
                viewModel.updateToTime(epochMillis)
                viewModel.closeToDatePicker()
            },
        )
    }

}


@Composable
private fun VideoPlayerControls(
    playerState: VideoPlayerState,
    viewModel: LossPreventionViewModel,
) {

    val uiState by viewModel.uiState.collectAsState()
    // TODO metadata overlay



    // Bottom controls bar
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.Black.copy(alpha = 0.5f))
//            .padding(horizontal = 8.dp, vertical = 4.dp)
        ,


    ) {

        val buttonContentPadding = PaddingValues(horizontal = 4.dp, vertical = 4.dp)


        val playPauseButtonWeight = 1.3f
        if (playerState.isPlaying) {
            Button({ playerState.pause() },
                colors = ButtonDefaults.buttonColors(containerColor = Color.Transparent),
                modifier = Modifier.weight(playPauseButtonWeight),
                contentPadding = buttonContentPadding
            ) {
                Icon(Icons.Default.Pause, contentDescription = "Pause", tint = Color.White)
                Text("Pause")
            }

        } else {
            Button({ playerState.play() },
                colors = ButtonDefaults.buttonColors(containerColor = Color.Transparent),
                modifier = Modifier.weight(playPauseButtonWeight),
                contentPadding = buttonContentPadding
            ) {
                Icon(Icons.Default.PlayArrow, contentDescription = "Play", tint = Color.White)
                Text("Play")
            }
        }



        // Scrub slider — sliderPos is a 0f..1f float
        Slider(
            value = playerState.sliderPos,
            onValueChange = { playerState.seekStart(it) },
            onValueChangeFinished = { playerState.seekFinished() },
            valueRange = 0f..1000f,
            modifier = Modifier.fillMaxWidth().weight(4f),
            colors = SliderDefaults.colors(
                thumbColor = Color.White,
                activeTrackColor = Color.White,
                inactiveTrackColor = Color.White.copy(alpha = 0.4f)
            )
        )


        uiState.videoUrl?.let {
            Button({ viewModel.downloadVideo(it) },
                colors = ButtonDefaults.buttonColors(containerColor = Color.Transparent),
                modifier = Modifier.fillMaxWidth().weight(1.3f),
                contentPadding = buttonContentPadding
                ) {
                Icon(Icons.Default.Download, contentDescription = "Download", tint = Color.White)
                Text("Download")
            }
        }


    }
}

@Composable
private fun FilterRow(
    modifier: Modifier = Modifier,
    viewModel: LossPreventionViewModel,
) {
    val uiState by viewModel.uiState.collectAsState()

    FlowRow(modifier = modifier, horizontalArrangement = Arrangement.spacedBy(4.dp)) {
        // Select branch dropdown
        DropdownMenu(
            label = "Store",
            items = uiState.branches,
            selectedItem = uiState.selectedBranch,
            itemLabel = { it.branchName ?: "Unnamed Store" },
            noneLabel = "All Stores",
            onItemSelected = { viewModel.selectBranch(it) },
            modifier = Modifier.weight(1f),
        )

        // Select employee dropdown
        DropdownMenu(
            label = "Employee",
            items = uiState.employees,
            selectedItem = uiState.selectedEmployee,
            itemLabel = { it.employeeName ?: "" },
            noneLabel = "All Employees",
            onItemSelected = { viewModel.selectEmployee(it) },
            modifier = Modifier.weight(1f),
        )

        // Select time range
        Button({ viewModel.openFromDatePicker() }, Modifier.weight(1f)) {
            Text("From ${uiState.fromMillis.tryFormatAsDateTime()}")
        }

        Button({ viewModel.openToDatePicker() }, Modifier.weight(1f)) {
            Text("To ${uiState.toMillis.tryFormatAsDateTime()}")
        }
    }
}


class LossPreventionViewModel : ViewModel() {

    val _uiState = MutableStateFlow(LossPreventionUiState())
    val uiState = _uiState.asStateFlow()
    val ktClient = KtorClient.instance.client


    suspend fun loadEmployees(parentCompany: ParentCompany) {
        val response = ktClient.get("/backoffice/employees/list") {
            parameter(ParentCompany::uuid.name, parentCompany.uuid)
        }
        val employees = response.body<List<EmployeeDTO>>()
        println("Loaded employees: ${employees.size}")
        _uiState.update { it.copy(employees = employees) }
    }

    suspend fun loadBranches() {
        val response = ktClient.get("/backoffice/store-management/list")
        val branches = response.body<List<CompanyBranch>>()
        println("Loaded branches: ${branches.size}")
        _uiState.update { it.copy(branches = branches) }
    }

    suspend fun loadTransactions() {
        println("Loading transactions")
        val response = ktClient.get("/backoffice/transactions/list") {
            parameter("from_millis", uiState.value.fromMillis)
            parameter("to_millis", uiState.value.toMillis)
            parameter("employee_uuid", uiState.value.selectedEmployee?.uuid)
            parameter("branch_uuid", uiState.value.selectedBranch?.uuid)
        }
        val transactions = response.body<List<PosTransactionDTO>>()
        println("Loaded Transactions: ${transactions.size}")
        _uiState.update { it.copy(transactions = transactions) }
    }


    suspend fun loadVideoUrl() {
        println("Loading video url")
        val response = ktClient.get("/backoffice/security/video") {
            parameter("transaction_id", uiState.value.selectedTransaction?.transactionId)
            parameter("pos_device_id", uiState.value.selectedTransaction?.posDeviceId)
        }
        val videoUrl = response.body<String>()
        println("Video url: $videoUrl")
        _uiState.update { it.copy(videoUrl = videoUrl) }
    }


    fun selectTransaction(transactionDTO: PosTransactionDTO) {
        _uiState.update { it.copy(selectedTransaction = transactionDTO, isLoadingVideo = true) }

        viewModelScope.launch {
            loadVideoUrl()
            _uiState.update { it.copy(isLoadingVideo = false) }
        }
    }

    // Branch & Employee selection
    fun selectBranch(branch: CompanyBranch?) {
        _uiState.update { it.copy(selectedBranch = branch) }
        viewModelScope.launch { loadTransactions() }
    }

    fun selectEmployee(employee: EmployeeDTO?) {
        _uiState.update { it.copy(selectedEmployee = employee) }
        viewModelScope.launch { loadTransactions() }
    }

    // Date Time entry
    fun openFromDatePicker() {
        _uiState.update { it.copy(showFromDatePicker = true) }
    }

    fun closeFromDatePicker() {
        _uiState.update { it.copy(showFromDatePicker = false) }
    }

    fun openToDatePicker() {
        _uiState.update { it.copy(showToDatePicker = true) }
    }

    fun closeToDatePicker() {
        _uiState.update { it.copy(showToDatePicker = false) }
    }

    fun updateFromTime(epochMillis: Long) {
        _uiState.update { it.copy(fromMillis = epochMillis) }
        viewModelScope.launch { loadTransactions() }
    }

    fun updateToTime(epochMillis: Long) {
        _uiState.update { it.copy(toMillis = epochMillis) }
        viewModelScope.launch { loadTransactions() }
    }

    fun downloadVideo(url: String) {
        viewModelScope.launch {
            val txn = uiState.value.selectedTransaction
            val fileName = "video_${txn?.transactionId ?: "unknown"}.mp4"
            downloadFileFromUrl(url, fileName)
        }
    }

}